// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"31624282","474":"bed8d0fd","515":"b335c643","575":"767fd07b","755":"e8abc19d","821":"e15c6d7d","849":"ee7d30ed","885":"d19aaaa7","898":"ac7bc7ce"}[chunkId] + ".chunk.js";
};